var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconMy02 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M11 2.117a4.008 4.008 0 1 0 0 8.016 4.008 4.008 0 0 0 0-8.016M5.258 6.125a5.742 5.742 0 1 1 11.484 0 5.742 5.742 0 0 1-11.484 0M4.044 13.383h13.913l3.6 9.218-1.614.631-3.17-8.115H5.227l-3.17 8.115-1.614-.63z",
  clipRule: "evenodd"
})));
export default SvgIconMy02;